<template>
	<div class="row pos-r bg-black">
		<a
			v-for="section in sectionRow"
			:style="{'background-image': 'url(' + section.background_url + ')'}"
			:href="section.landing_page_buttons[0].url"
			class="home-card col-xs-12 col-md-6 p-a-0 pos-r bg-featured-section"
			:key="section.id"
		>
			<div class="section-content-holder p-y-md p-x m-auto text-white front">
				<div class="content-title-holder">
					<h2>{{ section.title | stripTags }}</h2>
					<a :href="section.landing_page_buttons[0].url" class="link-btn link-white" >
						{{ section.landing_page_buttons[0].text }} <i class="fa fa-chevron-right"/>
					</a>
				</div>
				<img :src="section.logo_url" class="img-response-w section-logo">
				<div class="clearfix"/>
			</div>
		</a>
	</div>
</template>

<script>
export default {
	name: "SectionRow",
	props: {
		sectionRow: {
			type: Array,
			required: true
		}
	}
};
</script>

<style lang="scss" scoped>
.section-logo {
    width: 220px !important;
    margin: 17px auto 0px;

    @media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
        width: 170px !important;
    }
}

.bg-featured-section {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

</style>
